import { render } from "./ShowPoint.vue?vue&type=template&id=109b57e5"
import script from "./ShowPoint.vue?vue&type=script&lang=js"
export * from "./ShowPoint.vue?vue&type=script&lang=js"

import "./ShowPoint.vue?vue&type=style&index=0&id=109b57e5&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__